export class Permissoes{
    Pagar: boolean;
    Receber: boolean;
    EditarExcluir: boolean;
    NovosLancamentos: boolean;
    ReceberComCredito: boolean;
    Estorno: boolean;
    EmitirNota: boolean;
    Cliente: boolean;
}